import { render } from "./FilesScreen.vue?vue&type=template&id=1ab0d88c&scoped=true"
import script from "./FilesScreen.vue?vue&type=script&lang=js"
export * from "./FilesScreen.vue?vue&type=script&lang=js"

import "./FilesScreen.vue?vue&type=style&index=0&id=1ab0d88c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ab0d88c"

export default script